import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AnimatedSvgComponent } from './animated-svg.component';

@NgModule({
  imports: [CommonModule, AnimatedSvgComponent],
  exports: [AnimatedSvgComponent],
})
export class AnimatedSvgModule {}
